import Tag from '@sharedComponents/Tag';
import { useTranslation } from 'react-i18next';

const COLORS = { DRAFT: 'neutral', ONLINE: 'success', ARCHIVED: 'warning' };

/** Badge of the status of a test: 'DRAFT', 'ONLINE' or 'ARCHIVED'. Nothing shows without a status. */
const TestStatusBadge = ({ status = null }) => {
    const { t } = useTranslation('bo');
    const labels = { DRAFT: t('Draft'), ONLINE: t('Online'), ARCHIVED: t('Archived') };

    if (!COLORS[status]) return null;

    return (
        <Tag color={COLORS[status]} size="xs" fontSize="xs">
            {labels[status]}
        </Tag>
    );
};

export default TestStatusBadge;
